import React, { useState, useEffect } from "react";
import {
  Box, TextField, Button, Typography, Divider, Card,
  Grid
} from "@mui/material";
import { db, auth, storage } from "../firebase";
import { collection, getDocs, query, where, Timestamp, orderBy, onSnapshot } from "firebase/firestore";
import { Document, Page, Text, View, StyleSheet, pdf } from "@react-pdf/renderer";
import { addDoc, } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";


function Header() { // Pass data as props from your main state

  const signOut = () => {
    auth.signOut();
    localStorage.removeItem("email");
    localStorage.removeItem("password");
    window.location.href = "/login";
  };
 

  return (
    <div>
      <nav
        className="main-header navbar navbar-expand navbar-orange navbar-light"
        style={{
          background: "linear-gradient(90deg, #9a5006b3, #0b5a52)",
          padding: "0.5rem 1rem",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        }}
      >
        {/* Left navbar links */}
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link" data-widget="pushmenu" href="#0" role="button">
              <i className="fas fa-bars" style={{ color: "#fff", fontSize: 18, marginTop: 5 }} />
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#0">
              <b style={{ color: "#fff", textTransform: "uppercase", fontSize: 16 }}>
                FINTECH
              </b>
            </a>
          </li>
        </ul>

        {/* Right navbar links */}
        <ul className="navbar-nav ml-auto" style={{ marginLeft: "auto" }}>


          {/* Sync Button */}
          <li className="nav-item">
            <a
              className="nav-link"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.location.reload();
              }}
              title="Refresh Data"
            >
              <i className="fas fa-sync" style={{ color: "#fff", fontSize: 16 }}></i>
            </a>
          </li>

          {/* HIDE ON MOBILE: Navigation Buttons */}
          <li className="nav-item d-none d-md-block">
            <a className="nav-link" href="javascript:history.go(-1)" title="Go Back">
              <i className="fas fa-backward" style={{ color: "#fff", fontSize: 16 }} />
            </a>
          </li>

          <li className="nav-item d-none d-md-block">
            <a className="nav-link" href="javascript:history.go(+1)" title="Go Forward">
              <i className="fas fa-forward" style={{ color: "#fff", fontSize: 16 }} />
            </a>
          </li>


          {/* Sign Out */}
          <li className="nav-item">
            <a className="nav-link" onClick={signOut} href="#0" title="Sign Out">
              <i className="fa fa-sign-out" style={{ color: "#fff", fontSize: 16 }} />
            </a>
          </li>
        </ul>
      </nav>

      {/* Internal CSS */}
      <style>{`
        .navbar-nav .nav-link:hover {
          color: #ffd700 !important;
          transition: all 0.3s ease;
        }
        .navbar-nav .nav-item {
          margin-left: 0.8rem;
          display: flex;
          align-items: center;
        }
        @media (max-width: 768px) {
          .main-header .navbar-nav {
            flex-direction: row !important;
          }
          b { font-size: 13px !important; }
          .nav-item { margin-left: 0.4rem; }
        }
      `}</style>
    </div>
  );
}

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontFamily: 'Helvetica',
    fontSize: 10
  },
});


export default Header;